module.exports = __webpack_public_path__ + "static/media/0023.309f7c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48107/RAL/0023.png
// module id = 2653
// module chunks = 0